import { render } from "./spinnerDots.vue?vue&type=template&id=94da8d3e&scoped=true"
const script = {}

import "./spinnerDots.vue?vue&type=style&index=0&id=94da8d3e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94da8d3e"]])

export default __exports__